import type { AppState, GetterClass } from '../../../models'

export class FullscreenGetter implements GetterClass {
  static execute(this: void, state: AppState): boolean {
    return state.fullscreen
  }
}
